import React from 'react';
import PropTypes from 'prop-types';
import { StyledDayText } from './style';

const DayText = ({ date, className }) => (
  <StyledDayText className={className} format="dddd" element="span">
    {date}
  </StyledDayText>
);

DayText.propTypes = {
  date: PropTypes.string,
  className: PropTypes.string
};

export default DayText;
